@let g = group();
@let cols = columns();
@if (g) {
<div class="tr layout-row layout-align-start-center table-row"
     [class.odd]="index() % 2 === 1"
     [class.selected]="isSelected()"
     [class.status-approved]="isApproved()"
     [class.status-infeasible]="hasInfeasibility()">

  <!--Employee Name with expand icon-->
  <div class="td col-name layout-row layout-align-start-center">
    <bz-checkbox class="checkbox-spacing" size="sm"
                 appBringozIdGenerator="timecard-group-checkbox"
                 [checked]="isSelected()"
                 [indeterminate]="isIndeterminate()"
                 [ariaLabel]="g.agentReference?.fullName || ''"
                 (checkedChange)="onCheckboxToggle()">
    </bz-checkbox>

    @if (g.timeCards?.length) {
      <bz-button class="expand-btn" variant="tertiary" tone="primary" size="fit"
                 appBringozIdGenerator="timecard-group-expand-button"
                 [ariaLabel]="(isExpanded() ? 'Collapse' : 'Expand') | translate"
                 (clicked)="onToggleExpand($event)">
        <bz-icon [icon]="isExpanded() ? icons.expanded : icons.collapsed"></bz-icon>
      </bz-button>
    }

    <a class="br-link-1 text-ellipsis cursor-pointer" [title]="g.agentReference?.fullName"
       [class.margin-left-24]="!g.timeCards?.length" (click)="onRowSelect()">
      {{ g.agentReference?.fullName || '-' }}
    </a>
  </div>

  <!--Status-->
  @if (cols?.status?.enabled) {
    <div class="td col-status layout-row layout-align-start-center">
      <bz-tag [tone]="g.status | timecardStatusTone"
              [ngbTooltip]="statusTooltipTmpl"
              [disableTooltip]="!timeCardIds().length"
              openDelay="300"
              triggers="hover"
              container="body">{{ g.status }}</bz-tag>
      @if (hasInfeasibility()) {
        <bz-tag tone="danger">{{ 'Infeasible' | translate }}</bz-tag>
      }

      <ng-template #statusTooltipTmpl>
        <timecard-status-tooltip [timeCardIds]="timeCardIds()"></timecard-status-tooltip>
      </ng-template>
    </div>
  }

  <!--Employee ID-->
  @if (cols?.employeeId?.enabled) {
    <div class="td col-employeeId layout-row layout-align-start-center">
      <span class="br-body-2 gray-101 text-ellipsis" [title]="g.agentReference?.externalId">{{ g.agentReference?.externalId || '-' }}</span>
    </div>
  }

  <!--Employee Zip-->
  @if (cols?.employeeZip?.enabled) {
    <div class="td col-employeeZip layout-row layout-align-start-center">
      <span class="br-body-2 gray-101 text-ellipsis">{{ g.agentReference?.zipCode || '-' }}</span>
    </div>
  }

  <!--Job Title-->
  @if (cols?.jobTitle?.enabled) {
    <div class="td col-jobTitle layout-row layout-align-start-center">
      <app-bringoz-tags [tags]="g.agentReference?.tags" [maxTags]="1"
        [isShowTagDescriptions]="true"></app-bringoz-tags>
    </div>
  }

  <!--Branch-->
  @if (cols?.branch?.enabled) {
    <div class="td col-branch layout-row layout-align-start-center">
      <branches-indicator [branches]="g.branchReferences"></branches-indicator>
    </div>
  }

  <!--Distance-->
  @if (cols?.distance?.enabled) {
    <div class="td col-distance layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalDistanceMeter | bringozDistance:'---':false:0 }}</span>
    </div>
  }

  <!--Speed-->
  @if (cols?.mph?.enabled) {
    <div class="td col-mph layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.speedKmh | bringozSpeed }}</span>
    </div>
  }

  <!--Service Time-->
  @if (cols?.serviceTime?.enabled) {
    <div class="td col-serviceTime layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalServiceTimeDurationMillis  | bringozDurationExact }}</span>
    </div>
  }

  <!--Drive Time-->
  @if (cols?.driveTime?.enabled) {
    <div class="td col-driveTime layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalTravelTimeDurationMillis  | bringozDurationExact }}</span>
    </div>
  }

  <!--Admin Time-->
  @if (cols?.adminTime?.enabled) {
    <div class="td col-adminTime layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.totalAdminTime | bringozDurationExact }}</span>
    </div>
  }

  <!--PTO-->
  @if (cols?.pto?.enabled) {
    <div class="td col-pto layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ 0 | bringozDurationExact }}</span>
    </div>
  }

  <!--Paid Time-->
  @if (cols?.paidTime?.enabled) {
    <div class="td col-paidTime layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalTimeMillis  | bringozDurationExact }}</span>
    </div>
  }

  <!--Planned Time-->
  @if (cols?.plannedTime?.enabled) {
    <div class="td col-plannedTime layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.plannedTotals?.totalServiceTimeDurationMillis  | bringozDurationExact }}</span>
    </div>
  }

  <!--Stops-->
  @if (cols?.stops?.enabled) {
    <div class="td col-stops layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalStopsCount || 0 }}</span>
    </div>
  }

  <!--Break-->
  @if (cols?.break?.enabled) {
    <div class="td col-break layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">{{ g.totals?.reportedTotals?.totalBreakDurationMillis  | bringozDurationExact }}</span>
    </div>
  }

  <!--Off-->
  @if (cols?.off?.enabled) {
    <div class="td col-off layout-row layout-align-start-center">
      <span class="br-body-2 gray-101">00:00:00</span>
    </div>
  }

</div>
}
